import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import React, { Component } from 'react';
import ResetIcon from '../../static/_assets/informative-icons/reset.svg';
import TnTypography from '../tn-typography/TnTypography';

interface IProps {
  classes?: any;
  filterCount: number;
  resetAllFilters: any;
  excludeTable?: boolean;
}

interface IState {}

class FilterCount extends Component<IProps, IState> {
  render() {
    const { classes } = this.props;
    return (
      <Grid item xs={12} className={classes.filter}>
        <Grid container alignItems={'center'} className={classes.filterNote}>
          <Grid item>
            <TnTypography variant={'caption2'}>
              {this.props.excludeTable ? '' : 'Table'} Filters Applied ({this.props.filterCount})
            </TnTypography>
          </Grid>
          <Grid item>
            <Tooltip title={'Reset All Filters'}>
              <Button className={classes.button} onClick={this.props.resetAllFilters} data-testid={'Reset_Filters'}>
                <img src={ResetIcon} className={classes.resetIcon} />
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles((styles) => ({
  filter: {
    height: 18,
    zIndex: 2000,
  },
  filterNote: {
    width: 245,
  },
  button: {
    minWidth: 0,
  },
  resetIcon: {
    width: 18,
  },
}))(FilterCount);
